import React from 'react';
import { motion } from 'framer-motion';
import { Shield, UserCheck, Sparkles } from 'lucide-react';

const features = [
  {
    icon: Shield,
    title: 'Privacidade Absoluta',
    description: 'Seu perfil nunca aparece no Google. Modo incógnito disponível. Conversas criptografadas. Você decide quem vê suas fotos.',
    iconBg: 'bg-luxury-pink/20',
    border: 'border-luxury-pink/30',
    gradient: 'from-luxury-pink/5 to-transparent',
  },
  {
    icon: UserCheck,
    title: 'Perfis Verificados',
    description: 'Processo rigoroso de verificação garante autenticidade. Apenas membros reais e sérios.',
    iconBg: 'bg-luxury-mediumPink/20',
    border: 'border-luxury-mediumPink/30',
    gradient: 'from-luxury-mediumPink/5 to-transparent',
  },
  {
    icon: Sparkles,
    title: 'Sugar Dating sem Tabus',
    description: 'Daddies, Mommies e Babies em um ambiente feito para quem sabe o que quer e não tem medo de buscar.',
    iconBg: 'bg-luxury-lightPurple/20',
    border: 'border-luxury-lightPurple/30',
    gradient: 'from-luxury-lightPurple/5 to-transparent',
  },
];

const FeaturesSection = () => {
  return (
    <section className="relative py-12 md:py-32 px-4 bg-black">
      <div className="max-w-7xl mx-auto">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.6 }}
          className="text-center mb-10 md:mb-20"
        >
          <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-luxury-pink via-luxury-mediumPink to-luxury-lightPurple bg-clip-text text-transparent">
            Por que escolher Interlaced?
          </h2>
          <p className="text-white/60 text-lg max-w-2xl mx-auto">
            A única plataforma de sugar dating no Brasil focada em discrição, verificação e acordos transparentes
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-8">
          {features.map((feature, index) => (
            <motion.div
              key={index}
              initial={{ opacity: 0, y: 50 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.6, delay: index * 0.2 }}
            >
              <div
                className={`bg-gradient-to-br ${feature.gradient} backdrop-blur-sm border ${feature.border} rounded-2xl p-8 hover:scale-105 transition-all duration-300 group`}
              >
                <div className={`inline-flex p-4 rounded-full ${feature.iconBg} border ${feature.border} mb-6 group-hover:scale-110 transition-transform duration-300`}>
                  <feature.icon className="w-8 h-8 text-white" />
                </div>
                <h3 className="text-2xl font-semibold text-white mb-4">
                  {feature.title}
                </h3>
                <p className="text-white/60 leading-relaxed">
                  {feature.description}
                </p>
              </div>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default FeaturesSection;
